export function apiRoute(){
    return 'https://www.empoweryouth.com/';
}
export function fireBaseConfig(){
    return {
        apiKey: 'AIzaSyAiO2LZpxZOiGtdqgwq_HBSAKY4hR43044',
        authDomain: 'empoweryouth-chat.firebaseapp.com',
        databaseURL: 'https://empoweryouth-chat.firebaseio.com',
        projectId: 'empoweryouth-chat',
        storageBucket: 'empoweryouth-chat.appspot.com',
        messagingSenderId: '511988802799',
    };
}
export function paymentAccessToken(){
    return 'rzp_live_KeZeXK1FHxNq34';
}
